module.exports = __webpack_public_path__ + "media/images/cleaning/koceila@3x-7a745bd794b3dd7b0e28da1586ab734a.jpg";